import { CommonResponse, LEVEL_TYPE } from "./commonInterface.interface";

export enum SIGNUP_STEP {
  // SELECT_SIGNUP = "SIGN_UP",
  INPUT_INFO = "INPUT_INFO",
  SUCCESS = "SUCCESS",
  RESET_PASSWORD = "RESET_PASSWORD",
  RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS",
  TRIAL_SUCCESS = "TRIAL_SUCCESS",
  TRIAL_SEND_EMAIL = "TRIAL_SEND_EMAIL",
  RESELLER_SUBMISSION = "RESELLER_SUBMISSION",
  RESELLER_SIGNUP = "RESELLER_SIGNUP",
  FREE_TRIAL = "FREE_TRIAL",
  RESELLER_SIGNUP_SUCCESS = "RESELLER_SIGNUP_SUCCESS",
  RESELLER_SUBMISSION_SUCCESS = "RESELLER_SUBMISSION_SUCCESS",
  EXPIRED_TOKEN = "EXPIRED_TOKEN",
}

export type UseKeyType = "member" | "hidden";

export enum SIGNUP_STEP_TITLE {
  SIGN_UP = "Sign up on MyDW",
  INPUT_INFO = "Sign up on MyDW",
  SUCCESS = "",
  RESET_PASSWORD = "Reset Password",
  RESET_PASSWORD_SUCCESS = "",
  TRIAL_SUCCESS = "",
  RESELLER_SUBMISSION = "DW Channel Partner Program Application",
  RESELLER_SIGNUP = "Sign up on MyDW as a Channel Partner",
  FREE_TRIAL = "",
  RESELLER_SIGNUP_SUCCESS = "",
  RESELLER_SUBMISSION_SUCCESS = "",
  TRIAL_SEND_EMAIL = "",
  EXPIRED_TOKEN = "",
}

export enum SIGNUP_UPDATE_TYPE {
  FIRST_NAME = "FIRST_NAME",
  LAST_NAME = "LAST_NAME",
  PASSWORD = "PASSWORD",
  CONFIRM_PASSWORD = "CONFIRM_PASSWORD",
  PHONE_NUMBER = "PHONE_NUMBER",
  AGREEMENT = "AGREEMENT",
  TWOFACTOR = "TWOFACTOR",
  NOTIFYSMS = "NOTIFYSMS",
  EMAIL = "EMAIL",
  ORG_NAME = "ORG_NAME",
  ADDRESS = "ADDRESS",
  SLA_AGREED = "SLA_AGREED",
}

export enum PASSWORD_STATUS {
  VERY_POOR,
  POOR,
  OK,
  GOOD,
  EXCELLENT,
}

export enum RESELLER_CHECK_STEP {
  CHECK_EMAIL = "check_email",
  CHECKED_EMAIL = "checked_email",
  SIGN_UP_FORM = "sign_up_form",
}

export enum RESSELLER_USER_TYPE {
  SALESFORCE_USER = "salesforce_user",
  MYDW_USER = "mydw_user",
  NOT_SALESFORCE_USER = "not_salesforce_user",
  HAS_ORG = "has_org",
}
export interface ResellerUserInfo
  extends Omit<
    SignupUserInfo,
    | "phoneNumber"
    | "use2faCode"
    | "notifySms"
    | "parentAccount"
    | "isTrial"
    | "use2faCode"
  > {
  phone: string;
  companyName: string;
  email: string;
  timezone: string;
  dateFormat: string;
  timeFormat: string;
  slaAgreed: boolean;
}

export interface PostCheckEmailRequest {
  email: string;
}

export interface PostResellerSignUpRequest
  extends PostResellerSubmissionRequest {
  password: string;
  verifyPhone: boolean;
  timezone: string;
  dateFormat: string;
  timeFormat: string;
}
export interface PostResellerSignUpResponse extends CommonResponse {
  result: {
    email: string;
    userId: string;
    accountId: string;
  };
}
export interface PostResellerSubmissionRequest {
  email: string;
  firstName: string;
  lastName: string;
  companyName: string;
  phone: string;
}
export interface PostResellerSubmissionResponse extends CommonResponse {
  result: string;
}
export interface PostForgotEmailRequest {
  phoneNumber: string;
}

export interface GetTokenResponse {
  error: number;
  result: string;
}
export interface PostCheckEmailResponse {
  error_code: number;
  result: {
    isExist: boolean;
    isActivate: boolean;
  };
}

export interface ResellerInfo {
  companyName: string;
  name: string;
  cppNo: string;
}
export interface PostCheckResellerResponse extends CommonResponse {
  result: {
    isMyDW: boolean;
    isSalesforce: boolean;
    hasOrg: boolean;
  } & ResellerInfo;
}
export interface CloudTokenResponse {
  error: number;
  result: {
    token: string;
    provider: string;
    host: string;
    port: string;
    username: string;
  };
}
export interface NVRTokenResponse {
  error: number;
  result: string;
}

export interface NvrLinkTokenResponse extends CommonResponse {
  result: {
    ip: string;
    mac: string;
    p2p: number;
    auth: string;
    camMax: number;
  };
}

export interface PostForgotEmailResponse {
  error_code: number;
  result: PostForgotEmailRequest;
}

export interface GetLoginRequest {
  code: string;
}

export interface PostLoginRequest {
  email: string;
  password: string;
  device?: string;
  twoFactorType?: string;
  trustDevice?: boolean;
  remember2fa?: string; //UUID형식의 String. 2FA 진행 시 저장한 키값( 브라우져별로 localstorage에 저장)
}

export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  mfaToken: string;
  requiredTwoFactor: boolean;
  twoFactorNumber: string;
  use2faCode: "phone" | "email";
  userId: string;
  accountId: string;
  phoneNumber: string;
  userKey: string; //로그인 성공 시 백엔드에서 전달. AccessToken과 같이 HttpHeader에 [“Device-Id”] 로 전달.
  memberKey: string; //Login As에서 User로 입장
  hiddenKey: string; //Login As에서 Hidden으로 입장
  email?: string;
}
export interface PostLoginResponse {
  error: number;
  result: LoginResponse;
}

export interface GetLoginResponse {
  error: number;
  result: LoginResponse;
}

export interface CheckExistResponse extends CommonResponse {
  result: {
    isExist: boolean;
  };
}

export interface PostRegisterRequest {
  email: string;
  name: string;
  phone: string;
  password: string;
  parentAccount: string;
  use2faCode: "phone" | "email";
  notifySms: boolean;
}

export interface PostRegisterResponse extends CommonResponse {
  result: PostRegisterResponse;
}

export interface PostPasswordResetRequest {
  email: string;
  password: string;
}

export interface PostPasswordResetResponse {
  error: number;
  result: {
    email: string;
  };
}

export interface PostPhoneResendCordRequest {
  phoneNumber: string;
}

export interface PostEmailResendCordRequest {
  email: string;
}

export interface PostResendCordRequest {
  twoFactorType: string;
  isAuth: boolean;
  accessToken: string;
  email: string;
}

export interface PostResendCordResponse extends CommonResponse {
  result: {
    verifiedNumber: string;
    mfaToken: string;
  };
}

export interface ResponseNewToken extends CommonResponse {
  result: {
    accessToken: string;
    refreshToken: string;
    userKey: string;
  };
}

export interface VerifyInfoType {
  email: string;
  phone?: string;
}

export interface Verify2faRequest {
  email: string;
  accessToken: string;
  code: string;
  isAuth: boolean;
  checkedRemember2fa: boolean;
}
export interface Verify2faResponse {
  error: number;
  result: {
    remember2fa: string;
  };
}

export interface SignupUserInfo {
  firstName: string;
  lastName: string;
  password: string;
  confirmPassword: string;
  phoneNumber: string;
  agreement: boolean;
  parentAccount: string;
  use2faCode: "phone" | "email";
  notifySms: boolean;
  isTrial: boolean;
  verifyPhone: boolean;
}

export type ValueType = keyof (SignupUserInfo | ResellerUserInfo | FreeTrialInfo);
export type FreeTrialInfo = {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  address: string;
  orgName: string;
  isCP: boolean;
  businessType: string;
  timezone: string;
};

export interface PostFreeTrialSignUpResponse extends CommonResponse {
  result: FreeTrialInfo;
}

export interface challengeProps {
  challenge: string;
  rpId: string;
  rpName: string;
  timeout: number;
}

interface ChallengeResponseResult extends challengeProps {
  deviceName: string;
  sessionName: string;
  email: string;
}
export interface ChallengeResponse extends CommonResponse {
  result: ChallengeResponseResult;
}
export interface registerCredentialOption {
  credentialId: string;
  publicKey: string;
  credential: string;
}
export interface registerCredentialRequest extends registerCredentialOption {
  email: string;
  deviceName: string;
  sessionName: string;
}
export interface verifyCredentialOption {
  credentialId: string;
  authenticatorData: string;
  clientDataJSON: string;
  signature: string;
}
export interface verifyCredentialRequest extends verifyCredentialOption {
  deviceName: string;
  sessionName: string;
}

export interface LastPath {
  accountId: string;
  userType: string;
  accountLevel: LEVEL_TYPE;
}
